import { setProp } from "Store/Actions";
import { RootState, store } from "Store/mainStore";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

export const useLocalStateManagement = () => {
  /** Component states */
  const dispatch = useDispatch();
  const dynamicSelector = useSelector((state: RootState) => state.dynamic);
  const setState = (statename, value, fieldname?) => {
    if (dynamicSelector.data.localStates[statename] !== value) {
      // const stateCopy = {...dynamicSelector.data.localStates};
      const reduxstore = store.getState();
      let stateCopy = _.cloneDeep(reduxstore.dynamic.data.localStates);

      if (fieldname) {
        stateCopy[statename][fieldname] = value;
      } else {
        stateCopy[statename] = value;
      }
      dispatch(setProp({ slice: "dynamic", key: `localStates`, value: stateCopy }));
    }
  }

  const getState = (statename, fieldname?) => {
    const cleanName = 'set' + statename.charAt(0).toUpperCase() + statename.slice(1);
    const reduxstore = store.getState();
    return fieldname ? reduxstore?.dynamic?.data?.localStates?.[cleanName]?.[fieldname] : reduxstore?.dynamic?.data?.localStates?.[cleanName];
    // return fieldname ? reduxstore?.dynamic?.data?.localStates?.[cleanName]?.[fieldname] || undefined : reduxstore?.dynamic?.data?.localStates?.[cleanName] || undefined;
  }


  const setRef = (allRefs, item_id, value) => {
    // console.log("set ref" ,item_id, value)
    allRefs.current[item_id] = value;
  }

  const getRef = (allRefs, item_id) => {
    return allRefs.current[item_id];
  }

  return {
    setState,
    getState,
    setRef,
    getRef
  }
}